import { Monitor, Moon, Sun } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

import type { Theme } from '@/shared/providers/theme-provider'

export const THEME_OPTIONS: { value: Theme; label: string; icon: LucideIcon }[] =
  [
    { value: 'light', label: 'Light', icon: Sun },
    { value: 'dark', label: 'Dark', icon: Moon },
    { value: 'system', label: 'System', icon: Monitor },
  ]
